import { FC, PropsWithChildren } from 'react';
import BannerBg from 'common/components/BannerBg';
import cx from './TopLevelPageWrapper.module.css';

type Props = {};

export const TopLevelPageWrapper: FC<PropsWithChildren<Props>> = ({ children }) => {
  return (
    <>
      <BannerBg url="artist-list-banner@2x.png" height={200} className={cx('page-banner')} />
      <div className={cx('top-level-page-wrapper')}>{children}</div>
    </>
  );
};
